import { create } from "../../../../../common/utils/zustand_state_manager";
import { InitializePaginationProperties, InitializeSetPaginationProperties, PaginationProperties, SetPaginationProperties } from "../../../../../common/utils/pagination_property";

/**
 * useAssistenciaTecnicaCadastroPagination
 */

type State = {
  registroAtendimentos: PaginationProperties;
  pesquisaSatisfacao: PaginationProperties;
  arquivos: PaginationProperties;
};

type Actions = {
  registroAtendimentosSetter: SetPaginationProperties;
  pesquisaSatisfacaoSetter: SetPaginationProperties;
  arquivosSetter: SetPaginationProperties;
};

export const useAssistenciaTecnicaCadastroPagination = create<State & Actions>((set) => ({
  registroAtendimentos: InitializePaginationProperties(),
  registroAtendimentosSetter: InitializeSetPaginationProperties(set, 'registroAtendimentos'),
  pesquisaSatisfacao: InitializePaginationProperties(),
  pesquisaSatisfacaoSetter: InitializeSetPaginationProperties(set, 'pesquisaSatisfacao'),
  arquivos: InitializePaginationProperties(),
  arquivosSetter: InitializeSetPaginationProperties(set, 'arquivos'),
}));